import G2 from '@antv/g2'
G2.track(false)

export default G2
